import { Link, usePage } from "@inertiajs/react"

import { Button } from "@/components/ui/button"
import { Alert, AlertAction, AlertDescription } from "@/components/ui/alert"
import { paths } from "@/utils/paths"
import { useTranslations } from "@/utils/translations"

type SharedProps = {
  current_organization?: { id: number; name: string; subscription_plan: string; in_billing_grace?: boolean }
}

export function TrialBanner() {
  const { current_organization } = usePage<SharedProps>().props
  const { t } = useTranslations()

  if (!current_organization) return null

  if (current_organization.subscription_plan === "trial") {
    return (
      <Alert className="rounded-t-xl rounded-b-none border-warning bg-warning px-4 py-2 text-warning-foreground" role="status">
        <AlertDescription className="min-w-0 text-warning-foreground/80">
          <span className="font-medium text-warning-foreground">{t("trial_banner.trial.title")}</span>{" "}
          {t("trial_banner.trial.description")}
        </AlertDescription>
        <AlertAction>
          <Button
            variant="ghost"
            size="xs"
            className="h-auto px-2 text-xs text-warning-foreground hover:bg-warning-foreground/10 hover:text-warning-foreground"
            asChild
          >
            <Link href={paths.subscribe}>{t("trial_banner.trial.action")}</Link>
          </Button>
        </AlertAction>
      </Alert>
    )
  }

  if (current_organization.subscription_plan === "inactive") {
    return (
      <Alert variant="destructive" className="rounded-t-xl rounded-b-none border-destructive bg-destructive px-4 py-2 text-background">
        <AlertDescription className="min-w-0 text-background/80">
          <span className="font-medium text-background">{t("trial_banner.inactive.title")}</span>{" "}
          {t("trial_banner.inactive.description")}
        </AlertDescription>
        <AlertAction>
          <Button
            variant="ghost"
            size="xs"
            className="h-auto px-2 text-xs text-background hover:bg-background/10 hover:text-background"
            asChild
          >
            <Link href={paths.subscribe}>{t("trial_banner.inactive.action")}</Link>
          </Button>
        </AlertAction>
      </Alert>
    )
  }

  if (current_organization.in_billing_grace) {
    return (
      <Alert className="rounded-t-xl rounded-b-none border-warning bg-warning px-4 py-2 text-warning-foreground" role="status">
        <AlertDescription className="min-w-0 text-warning-foreground/80">
          <span className="font-medium text-warning-foreground">{t("trial_banner.past_due.title")}</span>{" "}
          {t("trial_banner.past_due.description")}
        </AlertDescription>
        <AlertAction>
          <Button
            variant="ghost"
            size="xs"
            className="h-auto px-2 text-xs text-warning-foreground hover:bg-warning-foreground/10 hover:text-warning-foreground"
            asChild
          >
            <Link href={paths.billing}>{t("trial_banner.past_due.action")}</Link>
          </Button>
        </AlertAction>
      </Alert>
    )
  }

  return null
}
